import { Address } from 'viem';

// Otherwise we cannot access process.env var using dynamic name in getEnvVar
const envVars = {
  NEXT_PUBLIC_SFS_BASE_URL: process.env.NEXT_PUBLIC_SFS_BASE_URL,
  NEXT_PUBLIC_BACKEND_API_URL: process.env.NEXT_PUBLIC_BACKEND_API_URL,
  NEXT_PUBLIC_EXPLORER_URL: process.env.NEXT_PUBLIC_EXPLORER_URL,

  NEXT_PUBLIC_TOKEN_DEPOSIT_GAS_LIMIT: process.env.NEXT_PUBLIC_TOKEN_DEPOSIT_GAS_LIMIT,
  NEXT_PUBLIC_POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST,

  NEXT_PUBLIC_SHOW_MAINTENANCE_INFO: process.env.NEXT_PUBLIC_SHOW_MAINTENANCE_INFO,
  NEXT_PUBLIC_SHOW_STREAMERS_PAGE: process.env.NEXT_PUBLIC_SHOW_STREAMERS_PAGE,

  NEXT_PUBLIC_IS_SYNTH: process.env.NEXT_PUBLIC_IS_SYNTH,

  NEXT_PUBLIC_CONTENTFUL_URL: process.env.NEXT_PUBLIC_CONTENTFUL_URL,
  NEXT_PUBLIC_SHOW_CONTENT_LIVE: process.env.NEXT_PUBLIC_SHOW_CONTENT_LIVE,
  NEXT_PUBLIC_CONTENTFUL_SPACE: process.env.NEXT_PUBLIC_CONTENTFUL_SPACE,
  NEXT_PUBLIC_CONTENTFUL_ENVIRONMENT: process.env.NEXT_PUBLIC_CONTENTFUL_ENVIRONMENT,
  NEXT_PUBLIC_CONTENTFUL_TOKEN: process.env.NEXT_PUBLIC_CONTENTFUL_TOKEN,
  NEXT_PUBLIC_CONTENTFUL_HOST: process.env.NEXT_PUBLIC_CONTENTFUL_HOST,

  NEXT_PUBLIC_L1_BRIDGE_ADDRESS: process.env.NEXT_PUBLIC_L1_BRIDGE_ADDRESS,
  NEXT_PUBLIC_L1_CHAIN_ID: process.env.NEXT_PUBLIC_L1_CHAIN_ID,
  NEXT_PUBLIC_L1_RPC: process.env.NEXT_PUBLIC_L1_RPC,
  NEXT_PUBLIC_L2_BRIDGE_ADDRESS: process.env.NEXT_PUBLIC_L2_BRIDGE_ADDRESS,
  NEXT_PUBLIC_L2_CHAIN_ID: process.env.NEXT_PUBLIC_L2_CHAIN_ID,
  NEXT_PUBLIC_L2_RPC: process.env.NEXT_PUBLIC_L2_RPC,

  NEXT_PUBLIC_LOCK_ADDRESS: process.env.NEXT_PUBLIC_LOCK_ADDRESS,
  NEXT_PUBLIC_MODE_TOKEN_ADDRESS: process.env.NEXT_PUBLIC_MODE_TOKEN_ADDRESS,
  NEXT_PUBLIC_LOCK_MODE_USDC_BPT_ADDRESS: process.env.NEXT_PUBLIC_LOCK_MODE_USDC_BPT_ADDRESS,
  NEXT_PUBLIC_MODE_USDC_BPT_TOKEN_ADDRESS: process.env.NEXT_PUBLIC_MODE_USDC_BPT_TOKEN_ADDRESS,
  NEXT_PUBLIC_MERKL_API: process.env.NEXT_PUBLIC_MERKL_API,
};

const getEnvVar = (name: keyof typeof envVars): string => {
  const value = envVars[name];
  if (!value) {
    throw new Error(`Environment variable ${name} is missing!`);
  }
  return value;
};

const localConfig = {
  sfsBaseUrl: getEnvVar('NEXT_PUBLIC_SFS_BASE_URL'),
  apiUrl: getEnvVar('NEXT_PUBLIC_BACKEND_API_URL'),
  explorerUrl: getEnvVar('NEXT_PUBLIC_EXPLORER_URL'),

  tokenDepositGasLimit: getEnvVar('NEXT_PUBLIC_TOKEN_DEPOSIT_GAS_LIMIT'),
  posthogHost: getEnvVar('NEXT_PUBLIC_POSTHOG_HOST'),

  contentfulUrl: getEnvVar('NEXT_PUBLIC_CONTENTFUL_URL'),
  showContentLive: getEnvVar('NEXT_PUBLIC_SHOW_CONTENT_LIVE') === 'true',
  contentfulSpace: getEnvVar('NEXT_PUBLIC_CONTENTFUL_SPACE'),
  contentfulEnvironment: getEnvVar('NEXT_PUBLIC_CONTENTFUL_ENVIRONMENT'),
  contentfulToken: getEnvVar('NEXT_PUBLIC_CONTENTFUL_TOKEN'),
  contentfulHost: getEnvVar('NEXT_PUBLIC_CONTENTFUL_HOST'),

  // feature flags
  showMaintenanceInfo: getEnvVar('NEXT_PUBLIC_SHOW_MAINTENANCE_INFO'),
  showStreamersPage: getEnvVar('NEXT_PUBLIC_SHOW_STREAMERS_PAGE') === 'true',

  isSynth: getEnvVar('NEXT_PUBLIC_IS_SYNTH') === 'true',

  // L1
  l1BridgeAddress: getEnvVar('NEXT_PUBLIC_L1_BRIDGE_ADDRESS') as Address,
  l1ChainId: getEnvVar('NEXT_PUBLIC_L1_CHAIN_ID'),
  l1Rpc: getEnvVar('NEXT_PUBLIC_L1_RPC'),

  // L2
  l2BridgeAddress: getEnvVar('NEXT_PUBLIC_L2_BRIDGE_ADDRESS') as Address,
  l2ChainId: getEnvVar('NEXT_PUBLIC_L2_CHAIN_ID'),
  l2Rpc: getEnvVar('NEXT_PUBLIC_L2_RPC'),

  // Lock
  lockAddress: getEnvVar('NEXT_PUBLIC_LOCK_ADDRESS') as Address,
  modeTokenAddress: getEnvVar('NEXT_PUBLIC_MODE_TOKEN_ADDRESS') as Address,

  lockModeUsdcBptAddress: getEnvVar('NEXT_PUBLIC_LOCK_MODE_USDC_BPT_ADDRESS') as Address,
  modeModeUsdcBptTokenAddress: getEnvVar('NEXT_PUBLIC_MODE_USDC_BPT_TOKEN_ADDRESS') as Address,

  merklAPI: getEnvVar('NEXT_PUBLIC_MERKL_API'),
};

export default localConfig;
